import React, { Component, createRef } from "react";

const connectStore = WrappedComponent => {
  class Connected extends Component {
    constructor(props) {
      super(props);
      this.connectedRef = createRef();
      this.store = window.ElementDataManager.get(props.element);
      this.state = {
        loaded: false,
        editorData: this.getStoreData()
      };
    }

    componentDidMount() {
      this.store.subscribe("update", this.handleStoreUpdate);
      this.setState({ loaded: true });
    }

    componentWillUnmount() {
      this.store.unsubscribe("update", this.handleStoreUpdate);
    }

    getStoreData = () => {
      return this.store.data;
    };

    handleStoreUpdate = newData => {
      this.setState({ editorData: newData });
    };

    render() {
      const { loaded, editorData } = this.state;
      if (!loaded) {
        return null;
      }

      const { connected, ...rest } = this.props;

      return (
        <WrappedComponent
          ref={this.connectedRef}
          editorData={editorData}
          store={this.store}
          {...rest}
        />
      );
    }
  }

  return Connected;
};

export default connectStore;
